@if (!errorDetail) {
    <tec-create-layout [formGroup]="form">
        <tec-item
            [title]="'WORKFLOWS.TITLE' | translate"
            [tagImage]="{icon: 'icon-flow', status: 'default'}"
            [highlight]="true">
            <tec-tag [status]="'success'">{{ 'BUTTON.NEW' | translate }} </tec-tag>
        </tec-item>

        @if (!workflowReady) {
            <tec-stepper-progress [steps]="steps" (clickEvent)="workflowsHelper.changeStep($event, steps, form, showError)" />
        }

        @if (workflowReady) {
            <ng-container content>
                <app-workflow-ready [data]="workflowData" />
            </ng-container>
        } @else {
            @if (showError) {
                <tec-alert
                    [hiddenCloseButton]="true"
                    [msg]="showError"
                    [status]="'warning'"
                    (closeAlert)="showError = ''"
                ></tec-alert>
            }
            @if (steps?.length) {
                <!-- Configuración -->
                @if (steps[0].selected) {
                    <ng-container [formGroupName]="workflowStep.GENERAL">
                        <div class="layout--60-40">
                            <div class="layout__column">
                                <!-- Detalles -->
                                <tec-tile [title]="'WORKFLOWS.FORM.GENERAL.DETAIL' | translate" icon="icon-capture-popup">
                                    <div class="grid grid-i2">
                                        @if (masterService.companies.length > 1) {
                                            <tec-form-group [label]="'WORKFLOWS.FORM.GENERAL.COMPANY' | translate"
                                                [errorMsg]="reactiveFormService.hasMsgError(form.get('general.company'))">
                                                <tec-select
                                                    [options]="companies"
                                                    formControlName="company"
                                                    [placeholder]="'WORKFLOWS.FORM.GENERAL.COMPANY_PLACEHOLDER' | translate"
                                                    [hasError]="reactiveFormService.hasError(form.get('general.company'))"
                                                    (valueChange)="updateOptionsByCompany()"
                                                ></tec-select>
                                            </tec-form-group>
                                        }
                                        @if (form.get('general.company').value) {
                                            <tec-form-group [label]="'WORKFLOWS.FORM.GENERAL.APIKEY' | translate"
                                                [errorMsg]="reactiveFormService.hasMsgError(form.get('general.api_key'))">
                                                <tec-select
                                                    [options]="apikeysOptions"
                                                    formControlName="api_key"
                                                    [placeholder]="'WORKFLOWS.FORM.GENERAL.APIKEY_PLACEHOLDER' | translate"
                                                    [linkLabel]="'BUTTON.ADD' | translate"
                                                    (linkEvent)="showCreateApikeyForm = true"
                                                    [hasError]="reactiveFormService.hasError(form.get('general.api_key'))"
                                                ></tec-select>
                                            </tec-form-group>
                                        }
                                        <tec-form-group [label]="'WORKFLOWS.FORM.GENERAL.NAME' | translate"
                                            [errorMsg]="reactiveFormService.hasMsgError(form.get('general.alias'))">
                                            <tec-input formControlName="alias"
                                                [hasError]="reactiveFormService.hasError(form.get('general.alias'))"
                                                [placeholder]="'WORKFLOWS.FORM.GENERAL.NAME_PLACEHOLDER' | translate"
                                            ></tec-input>
                                        </tec-form-group>
                                        @if (form.get('general.company').value) {
                                            <tec-form-group [label]="'WORKFLOWS.FORM.GENERAL.THEME_DESIGN' | translate"
                                                [errorMsg]="reactiveFormService.hasMsgError(form.get('general.theme'))">
                                                <tec-select
                                                    [options]="themeOptions"
                                                    formControlName="theme"
                                                    [placeholder]="'WORKFLOWS.FORM.GENERAL.THEME_DESIGN_PLACEHOLDER' | translate"
                                                    [linkLabel]="'BUTTON.ADD' | translate"
                                                    (linkEvent)="createTheme()"
                                                    [hasError]="reactiveFormService.hasError(form.get('general.theme'))"
                                                ></tec-select>
                                            </tec-form-group>
                                        }
                                    </div>

                                    @if (company?.manual_validation === true) {
                                        <tec-form-group
                                            [label]="'WORKFLOWS.FORM.GENERAL.VALIDATION_TYPE' | translate"
                                            [errorMsg]="reactiveFormService.hasMsgError(form.get('general.validation'))"
                                        >
                                            <tec-toggle
                                                formControlName="validation"
                                                [options]="[
                                                    {
                                                        id: 'auto',
                                                        label: 'WORKFLOWS.FORM.GENERAL.VALIDATION_TYPE_OPT.AUTO' | translate,
                                                        tooltip: 'WORKFLOWS.FORM.GENERAL.VALIDATION_TYPE_OPT.AUTO_TOOLTIP' | translate
                                                    }, {
                                                        id: 'manual',
                                                        label: 'WORKFLOWS.FORM.GENERAL.VALIDATION_TYPE_OPT.MANUAL' | translate,
                                                        tooltip: 'WORKFLOWS.FORM.GENERAL.VALIDATION_TYPE_OPT.MANUAL_TOOLTIP' | translate
                                                    }
                                                ]"
                                                [multiple]="false"
                                                [value]="form.get('general.validation').value"
                                            ></tec-toggle>
                                        </tec-form-group>

                                        @if ((form.get('general.validation').value?.id || form.get('general.validation').value) === 'manual') {
                                            <tec-item
                                                [title]="'WORKFLOWS.FORM.GENERAL.VALIDATION_PROCESS_MANUAL_QUESTION' | translate"
                                                [tagImage]="{ icon: 'icon-user', status: 'default' }"
                                                [clickeable]="false"
                                            >
                                                <tec-toggle
                                                    formControlName="validation_manual_type"
                                                    [options]="[
                                                        { id: 'approved', label: 'WORKFLOWS.FORM.GENERAL.VALIDATION_PROCESS_MANUAL_APPROVED' | translate },
                                                        { id: 'rejected', label: 'WORKFLOWS.FORM.GENERAL.VALIDATION_PROCESS_MANUAL_REJECTED' | translate }
                                                    ]"
                                                    [multiple]="true"
                                                    requireSelection
                                                ></tec-toggle>
                                            </tec-item>

                                            @if (isValidationManualRejectedSelected(form.get('general.validation_manual_type').value)) {
                                                <tec-form-group
                                                    [label]="'WORKFLOWS.FORM.GENERAL.VALIDATION_PROCESS_MANUAL_ERRORS_TITLE' | translate"
                                                    [description]="'WORKFLOWS.FORM.GENERAL.VALIDATION_PROCESS_MANUAL_ERRORS_DESCRIPTION' | translate"
                                                >
                                                    <tec-select
                                                        multiple
                                                        formControlName="validation_manual_errors"
                                                        [placeholder]="'WORKFLOWS.FORM.GENERAL.VALIDATION_PROCESS_MANUAL_ERRORS_PLACEHOLDER' | translate"
                                                        [options]="validationProcessErrorsOptions"
                                                    ></tec-select>
                                                </tec-form-group>
                                            }

                                            <tec-form-group
                                                [label]="'WORKFLOWS.FORM.GENERAL.VALIDATION_EMAILS' | translate"
                                                [description]="'WORKFLOWS.FORM.GENERAL.VALIDATION_EMAILS_DESCRIPTION' | translate"
                                            >
                                                <tec-textarea
                                                    formControlName="validation_email"
                                                    placeholder="email@emaill.com, email@mail.com,"
                                                ></tec-textarea>
                                            </tec-form-group>
                                        }
                                    }
                                </tec-tile>

                                <!-- Recolección de datos -->
                                <tec-tile [title]="'WORKFLOWS.FORM.GENERAL.GET_DATA' | translate" icon="icon-file">
                                    <tec-item [title]="'WORKFLOWS.FORM.GENERAL.LOCATION' | translate"
                                        [tagImage]="{icon: 'icon-map-pin', status:'default'}">
                                        <tec-list-detail>
                                            <span>{{ 'WORKFLOWS.FORM.GENERAL.LOCATION_DESCRIPTION' | translate }}</span>
                                        </tec-list-detail>
                                        <tec-switch formControlName="location" size="sm" />
                                    </tec-item>

                                    <tec-item [title]="'WORKFLOWS.FORM.GENERAL.REQUIRED_RECORDING' | translate" [tagImage]="{icon: 'icon-video-camera', status:'default'}">
                                        <tec-list-detail>
                                            <span>{{ 'WORKFLOWS.FORM.GENERAL.REQUIRED_RECORDING_DESCRIPTION' | translate }}</span>
                                        </tec-list-detail>
                                        <tec-switch formControlName="required_recording" size="sm"></tec-switch>
                                    </tec-item>

                                    <!-- Avanzado -->
                                    <app-workflow-form-advanced-collapse [expanded]="id">
                                        <div class="item-group">
                                            <tec-item [classes]="['item--outline']"
                                                [title]="'WORKFLOWS.FORM.GENERAL.INCLUDE_IMAGES' | translate"
                                                [tagImage]="{icon: 'icon-image'}">
                                                <tec-list-detail>
                                                    <span>{{ 'WORKFLOWS.FORM.GENERAL.INCLUDE_IMAGES_DESCRIPTION' | translate }}</span>
                                                </tec-list-detail>
                                                <tec-switch formControlName="include_images" size="sm"></tec-switch>
                                            </tec-item>
                                            <tec-divider></tec-divider>
                                            <tec-item [classes]="['item--outline']"
                                                [title]="'PROCESSES.CREATE_MODAL.EXPIRATION' | translate"
                                                [tagImage]="{icon: 'icon-clock'}">
                                                <tec-list-detail>
                                                    <span>{{ 'WORKFLOWS.FORM.GENERAL.TOKEN_DURATION_DESCRIPTION' | translate }}</span>
                                                </tec-list-detail>
                                                <tec-form-group>
                                                    <tec-select
                                                        formControlName="token_duration_minutes"
                                                        [options]="tokenDurationOptions"
                                                        [placeholder]="'PROCESSES.CREATE_MODAL.EXPIRATION_PLACEHOLDER' | translate"
                                                    ></tec-select>
                                                </tec-form-group>
                                            </tec-item>
                                            <tec-divider></tec-divider>
                                            <tec-item [classes]="['item--outline']"
                                                [title]="'WORKFLOWS.FORM.GENERAL.DATA_RETENTION' | translate"
                                                [tagImage]="{icon: 'icon-clock'}">
                                                <tec-list-detail>
                                                    <span>{{ 'WORKFLOWS.FORM.GENERAL.DATA_RETENTION_DESCRIPTION' | translate }}</span>
                                                </tec-list-detail>
                                                <tec-switch formControlName="override_data_retention" size="sm"></tec-switch>
                                            </tec-item>
                                            @if (form.get('general.override_data_retention')?.value) {
                                                <div class="workflow-data-retention grid grid-i2">
                                                    <app-retention-duration-input
                                                        formControlName="document_retention_days"
                                                        [label]="'COMPANIES.FORM.DOCUMENT_RETENTION_DAYS' | translate"
                                                        [hasError]="retentionHasError(form.get('general.document_retention_days'))"
                                                    />
                                                    <app-retention-duration-input
                                                        formControlName="media_retention_days"
                                                        [label]="'COMPANIES.FORM.MEDIA_RETENTION_DAYS' | translate"
                                                        [hasError]="retentionHasError(form.get('general.media_retention_days'))"
                                                    />
                                                    <app-retention-duration-input
                                                        formControlName="info_retention_days"
                                                        [label]="'COMPANIES.FORM.INFO_RETENTION_DAYS' | translate"
                                                        [hasError]="retentionHasError(form.get('general.info_retention_days'))"
                                                    />
                                                </div>
                                            }
                                        </div>
                                    </app-workflow-form-advanced-collapse>
                                </tec-tile>

                                <!-- Acceso -->
                                <tec-tile [title]="'WORKFLOWS.FORM.GENERAL.ACCESS' | translate" icon="icon-open-web">
                                    <tec-item [title]="'WORKFLOWS.FORM.GENERAL.ALLOWED_DEVICE' | translate" [tagImage]="{icon: 'icon-smartphone', status:'default'}">
                                        <tec-list-detail>
                                            <span>{{ 'WORKFLOWS.FORM.GENERAL.ALLOWED_DEVICE_DESCRIPTION' | translate }}</span>
                                        </tec-list-detail>
                                        <tec-toggle
                                            formControlName="allowed_device"
                                            [options]="allowedDevices"
                                            requireSelection
                                            [multiple]="true"
                                        ></tec-toggle>
                                    </tec-item>

                                    @if (!form.get('general.required_recording').value) {
                                        <tec-item [title]="'WORKFLOWS.FORM.GENERAL.HAS_SAVED_STATE' | translate"
                                            [tagImage]="{icon: 'icon-refresh', status:'default'}">
                                            <tec-list-detail>
                                                <span>{{ 'WORKFLOWS.FORM.GENERAL.HAS_SAVED_STATE_DESCRIPTION' | translate }}</span>
                                            </tec-list-detail>
                                            <tec-toggle
                                                formControlName="has_saved_state"
                                                [options]="[
                                                    {
                                                        id: 'true',
                                                        tooltip: 'WORKFLOWS.FORM.GENERAL.HAS_SAVED_STATE_CONTINUE_TOOLTIP' | translate,
                                                        label: 'BUTTON.CONTINUE' | translate
                                                    },
                                                    {
                                                        id: 'false',
                                                        tooltip: 'WORKFLOWS.FORM.GENERAL.HAS_SAVED_STATE_RESET_TOOLTIP' | translate,
                                                        label: 'BUTTON.RESET' | translate
                                                    }
                                                ]"
                                                [multiple]="false"
                                                requireSelection
                                            ></tec-toggle>
                                        </tec-item>
                                    }

                                    <tec-item
                                        [title]="'WORKFLOWS.FORM.GENERAL.ALERT_POSTERGADO' | translate"
                                        [tagImage]="{ icon: 'icon-message-circle', status:'default' }"
                                        [clickeable]="false"
                                    >
                                        <tec-list-detail>
                                            <span>{{ 'WORKFLOWS.FORM.GENERAL.ALERT_POSTERGADO_DESCRIPTION' | translate }}</span>
                                        </tec-list-detail>
                                        <div subheader class="item-group" style="padding: 12px;">
                                            <tec-form-group [label]="'WORKFLOWS.FORM.GENERAL.ALERT_POSTERGADO_VISIBILITY' | translate">
                                                <tec-toggle
                                                    formControlName="delayed_process_warning_visibility"
                                                    [options]="[
                                                        { id: 'start_and_resume', label: 'WORKFLOWS.FORM.GENERAL.ALERT_POSTERGADO_VISIBILITY_START_AND_RESUME' | translate },
                                                        { id: 'resume_only', label: 'WORKFLOWS.FORM.GENERAL.ALERT_POSTERGADO_VISIBILITY_RESUME_ONLY' | translate }
                                                    ]"
                                                    [multiple]="false"
                                                    requireSelection
                                                />
                                            </tec-form-group>
                                            <tec-form-group [label]="'WORKFLOWS.FORM.GENERAL.ALERT_POSTERGADO_MESSAGE' | translate">
                                                <tec-toggle
                                                    formControlName="delayed_process_warning_text_type"
                                                    [options]="[
                                                        { id: 'default', label: 'WORKFLOWS.FORM.GENERAL.ALERT_POSTERGADO_DEFAULT' | translate },
                                                        { id: 'custom', label: 'WORKFLOWS.FORM.GENERAL.ALERT_POSTERGADO_CUSTOM' | translate }
                                                    ]"
                                                    [multiple]="false"
                                                    requireSelection
                                                />
                                            </tec-form-group>
                                            <div id="workflow-locale-anchor-delayed" class="workflow-locale-anchor">
                                                <tec-tabs
                                                    [tabs]="workflowLocaleTabs"
                                                    (tabSelected)="onWorkflowLocaleTabSelected($event)"
                                                />
                                                <tec-form-group>
                                                    <tec-textarea
                                                        [formControl]="getWorkflowLocaleControl('general', 'delayed_process_warning_text', selectedWorkflowLocaleId)"
                                                        [placeholder]="getDelayedWarningPlaceholder()"
                                                        [hasError]="reactiveFormService.hasError(getWorkflowLocaleControl('general', 'delayed_process_warning_text', selectedWorkflowLocaleId)) || reactiveFormService.hasError(form.get('general.delayed_process_warning_text'))"
                                                    />
                                                </tec-form-group>
                                            </div>
                                        </div>
                                    </tec-item>

                                    <tec-item
                                        [title]="'WORKFLOWS.FORM.GENERAL.TWO_FACTOR_AUTH' | translate"
                                        [tagImage]="{ icon: 'icon-shield', status:'default' }"
                                        [clickeable]="false"
                                    >
                                        <tec-list-detail>
                                            <span>{{ 'WORKFLOWS.FORM.GENERAL.TWO_FACTOR_AUTH_DESCRIPTION' | translate }}</span>
                                        </tec-list-detail>
                                        <tec-toggle
                                            formControlName="two_factor_channel"
                                            [options]="twoFactorChannelOptions"
                                            [multiple]="false"
                                            requireSelection
                                        ></tec-toggle>
                                        @if (isTwoFactorWorkflowEnabled()) {
                                            <div subheader class="item-group" style="padding: 12px;">
                                                <tec-alert
                                                    status="warning"
                                                    [msg]="'WORKFLOWS.FORM.GENERAL.TWO_FACTOR_AUTH_NOTICE' | translate"
                                                    hiddenCloseButton
                                                ></tec-alert>
                                            </div>
                                        }
                                    </tec-item>

                                    <!-- Avanzado -->
                                    <app-workflow-form-advanced-collapse [expanded]="id">
                                        <div class="item-group">
                                            <tec-item [classes]="['item--outline']"
                                                [title]="'WORKFLOWS.FORM.GENERAL.SDK' | translate"
                                                [tagImage]="{icon: 'icon-smartphone'}">
                                                <tec-list-detail>
                                                    <span>{{ 'WORKFLOWS.FORM.GENERAL.SDK_DESCRIPTION' | translate }}</span>
                                                </tec-list-detail>
                                                <tec-switch formControlName="sdk" size="sm"></tec-switch>
                                            </tec-item>
                                        </div>
                                    </app-workflow-form-advanced-collapse>
                                </tec-tile>
                            </div>

                            <!-- Antifraude -->
                            <tec-tile
                                [title]="'WORKFLOWS.FORM.GENERAL.ANTIFRAUDE_GENERAL' | translate"
                                [subtitle]="'WORKFLOWS.FORM.GENERAL.ANTIFRAUDE_GENERAL_DESCRIPTION' | translate"
                                icon="icon-shield"
                                formGroupName="antifraud">

                                <tec-item [title]="'WORKFLOWS.FORM.GENERAL.BLOCK_OPERATION' | translate"
                                    [tagImage]="{icon: 'icon-x-circle', status:'notice'}">
                                    <tec-list-detail>
                                        <span>{{ 'WORKFLOWS.FORM.GENERAL.BLOCK_OPERATION_DESCRIPTION' | translate }}</span>
                                    </tec-list-detail>
                                    <tec-switch formControlName="block_operation" size="sm"></tec-switch>
                                </tec-item>

                                <tec-item [title]="'WORKFLOWS.FORM.GENERAL.EMAIL_ALERT' | translate"
                                    [tagImage]="{icon: 'icon-mail', status:'notice'}">
                                    <tec-list-detail>
                                        <span>{{ 'WORKFLOWS.FORM.GENERAL.EMAIL_ALERT_DESCRIPTION' | translate }}</span>
                                    </tec-list-detail>
                                    <tec-switch formControlName="available_email_alert" size="sm"></tec-switch>
                                    @if (form.get('general.antifraud.available_email_alert').value) {
                                        <div subheader style="padding: 12px;">
                                            <tec-form-group [errorMsg]="reactiveFormService.hasMsgError(form.get('general.antifraud.email_alert'))">
                                                <tec-textarea
                                                    formControlName="email_alert"
                                                    placeholder="email@emaill.com, email@mail.com,"
                                                    [hasError]="reactiveFormService.hasError(form.get('general.antifraud.email_alert'))"
                                                ></tec-textarea>
                                            </tec-form-group>
                                        </div>
                                    }
                                </tec-item>

                                <tec-tile [title]="'WORKFLOWS.FORM.GENERAL.ANTIFRAUDE_GENERAL_WORKFLOW' | translate"
                                    [subtitle]="'WORKFLOWS.FORM.GENERAL.ANTIFRAUDE_GENERAL_WORKFLOW_DESCRIPTION' | translate">
                                    <div class="item-group">
                                        <tec-item [classes]="['item--outline']" [title]="'WORKFLOWS.FORM.GENERAL.IP' | translate">
                                            <tec-switch formControlName="ip_block" size="sm"></tec-switch>
                                        </tec-item>
                                        <tec-divider></tec-divider>
                                        <tec-item [classes]="['item--outline']" [title]="'WORKFLOWS.FORM.GENERAL.IDENTIFIER_BLOCK' | translate">
                                            <tec-switch formControlName="identifier_block" size="sm"></tec-switch>
                                        </tec-item>
                                        <tec-divider></tec-divider>
                                        <tec-item [classes]="['item--outline']" [title]="'WORKFLOWS.FORM.GENERAL.FACE' | translate">
                                            <tec-switch formControlName="face_block" size="sm"></tec-switch>
                                        </tec-item>
                                    </div>
                                </tec-tile>
                            </tec-tile>
                        </div>
                    </ng-container>
                }

                <!-- Operaciones -->
                @if (steps[1].selected) {
                    <ng-container [formGroupName]="workflowStep.OPERATIONS">
                        @if (!showOperationsDetail) {
                            <tec-tile [title]="'WORKFLOWS.FORM.OPERATIONS.TITLE' | translate"
                                [subtitle]="'WORKFLOWS.FORM.OPERATIONS.SUBTITLE' | translate"
                                icon="icon-list">
                                <div class="grid grid-e4-sm">
                                    <tec-card-select
                                        [formGroupName]="OPERATION_TYPE.HOME"
                                        [img]="form.get(`operations.${OPERATION_TYPE.HOME}.available`)?.value ? 'images/workflow-home.png' : 'images/workflow-home-unselect.png'"
                                        [title]="'WORKFLOWS.FORM.OPERATIONS.HOME' | translate"
                                        [description]="'WORKFLOWS.FORM.OPERATIONS.HOME_DESCRIPTION' | translate"
                                        [selected]="form.get(`operations.${OPERATION_TYPE.HOME}.available`)?.value"
                                        (selectedChange)="form.get(`operations.${OPERATION_TYPE.HOME}.available`).patchValue($event)"
                                    ></tec-card-select>
                                    <tec-card-select
                                        [formGroupName]="OPERATION_TYPE.FORM"
                                        [img]="form.get(`operations.${OPERATION_TYPE.FORM}.available`)?.value ? 'images/workflow-form.png' : 'images/workflow-form-unselect.png'"
                                        [title]="'WORKFLOWS.FORM.OPERATIONS.FORM' | translate"
                                        [description]="'WORKFLOWS.FORM.OPERATIONS.FORM_DESCRIPTION' | translate"
                                        [selected]="form.get(`operations.${OPERATION_TYPE.FORM}.available`)?.value"
                                        (selectedChange)="form.get(`operations.${OPERATION_TYPE.FORM}.available`).patchValue($event)"
                                    ></tec-card-select>
                                    <tec-card-select
                                        [formGroupName]="OPERATION_TYPE.OCR"
                                        [img]="form.get(`operations.${OPERATION_TYPE.OCR}.available`)?.value ? 'images/workflow-ocr.png' : 'images/workflow-ocr-unselect.png'"
                                        [title]="'WORKFLOWS.FORM.OPERATIONS.OCR' | translate"
                                        [description]="'WORKFLOWS.FORM.OPERATIONS.OCR_DESCRIPTION' | translate"
                                        [selected]="form.get(`operations.${OPERATION_TYPE.OCR}.available`)?.value"
                                        (selectedChange)="form.get(`operations.${OPERATION_TYPE.OCR}.available`).patchValue($event)"
                                    ></tec-card-select>
                                    <tec-card-select
                                        [formGroupName]="OPERATION_TYPE.POL"
                                        [img]="form.get(`operations.${OPERATION_TYPE.POL}.available`)?.value ? 'images/workflow-pol.png' : 'images/workflow-pol-unselect.png'"
                                        [title]="'WORKFLOWS.FORM.OPERATIONS.POL' | translate"
                                        [description]="'WORKFLOWS.FORM.OPERATIONS.POL_DESCRIPTION' | translate"
                                        [selected]="form.get(`operations.${OPERATION_TYPE.POL}.available`)?.value"
                                        (selectedChange)="form.get(`operations.${OPERATION_TYPE.POL}.available`).patchValue($event)"
                                    ></tec-card-select>
                                    <tec-card-select
                                        [formGroupName]="OPERATION_TYPE.ATTORNEY_POWERS"
                                        [img]="form.get(`operations.${OPERATION_TYPE.ATTORNEY_POWERS}.available`)?.value ? 'images/workflow-attorney-powers.png' : 'images/workflow-attorney-powers-unselect.png'"
                                        [title]="'WORKFLOWS.FORM.OPERATIONS.ATTORNEY_POWERS' | translate"
                                        [description]="'WORKFLOWS.FORM.OPERATIONS.ATTORNEY_POWERS_DESCRIPTION' | translate"
                                        [selected]="form.get(`operations.${OPERATION_TYPE.ATTORNEY_POWERS}.available`)?.value"
                                        (selectedChange)="form.get(`operations.${OPERATION_TYPE.ATTORNEY_POWERS}.available`).patchValue($event)"
                                    ></tec-card-select>
                                    <tec-card-select
                                        [formGroupName]="OPERATION_TYPE.DOCUMENTS"
                                        [img]="form.get(`operations.${OPERATION_TYPE.DOCUMENTS}.available`)?.value ? 'images/workflow-docs.png' : 'images/workflow-docs-unselect.png'"
                                        [title]="'WORKFLOWS.FORM.OPERATIONS.DOCUMENTS' | translate"
                                        [description]="'WORKFLOWS.FORM.OPERATIONS.DOCUMENTS_DESCRIPTION' | translate"
                                        [selected]="form.get(`operations.${OPERATION_TYPE.DOCUMENTS}.available`)?.value"
                                        (selectedChange)="form.get(`operations.${OPERATION_TYPE.DOCUMENTS}.available`).patchValue($event)"
                                    ></tec-card-select>
                                    <tec-card-select
                                        [formGroupName]="OPERATION_TYPE.CONNECTIONS"
                                        [img]="form.get(`operations.${OPERATION_TYPE.CONNECTIONS}.available`)?.value ? 'images/workflow-eval.png' : 'images/workflow-eval-unselect.png'"
                                        [title]="'WORKFLOWS.FORM.OPERATIONS.CONNECTIONS' | translate"
                                        [description]="'WORKFLOWS.FORM.OPERATIONS.CONNECTIONS_DESCRIPTION' | translate"
                                        [selected]="form.get(`operations.${OPERATION_TYPE.CONNECTIONS}.available`)?.value"
                                        (selectedChange)="form.get(`operations.${OPERATION_TYPE.CONNECTIONS}.available`).patchValue($event)"
                                    ></tec-card-select>
                                </div>
                            </tec-tile>
                        }
                        @if (showOperationsDetail) {
                            <div class="layout--40-60">
                                <tec-tile [title]="'WORKFLOWS.FORM.OPERATIONS.TITLE' | translate"
                                    icon="icon-list">
                                    <ng-container actions>
                                        <tec-link [label]="'BUTTON.BACK' | translate" (click)="showOperationsDetail = false"></tec-link>
                                    </ng-container>
                                    @for (operation of operationsFiltered; track operation; let i = $index; let last = $last) {
                                        <tec-item [title]="operation.title"
                                            [tagImage]="{img: operation.image}"
                                            [selected]="operation.selected"
                                            [disabled]="operation.disabled"
                                            (click)="changeOperationSelected(operation)"
                                        ></tec-item>
                                    }
                                </tec-tile>
                                <!-- OPERATIONS -->
                                <div class="layout__column">
                                    @for (operation of operationsFiltered; track operation; let i = $index; let last = $last) {
                                        <!-- HOME -->
                                        @if (operation.type === OPERATION_TYPE.HOME && form.get(`operations.${OPERATION_TYPE.HOME}.available`).value && operation.selected) {
                                        	<app-workflow-form-home-panel [host]="asOperationPanelHost" [operation]="operation" />
                                        }

                                        <!-- FORM -->
                                        @if (operation.type === OPERATION_TYPE.FORM && form.get(`operations.${OPERATION_TYPE.FORM}.available`).value && operation.selected) {
                                        	<app-workflow-form-form-panel [host]="asOperationPanelHost" [operation]="operation" />
                                        }

                                        <!-- OCR -->
                                        @if (operation.type === OPERATION_TYPE.OCR && form.get(`operations.${OPERATION_TYPE.OCR}.available`).value && operation.selected) {
                                        	<app-workflow-form-ocr-panel [host]="asOperationPanelHost" [operation]="operation" />
                                        }

                                        <!-- POL -->
                                        @if (operation.type === OPERATION_TYPE.POL && form.get(`operations.${OPERATION_TYPE.POL}.available`).value && operation.selected) {
                                        	<app-workflow-form-pol-panel [host]="asOperationPanelHost" [operation]="operation" />
                                        }

                                        <!-- ATTORNEY_POWERS -->
                                        @if (operation.type === OPERATION_TYPE.ATTORNEY_POWERS && form.get(`operations.${OPERATION_TYPE.ATTORNEY_POWERS}.available`).value && operation.selected) {
                                        	<app-workflow-form-attorney-powers-panel [host]="asOperationPanelHost" [operation]="operation" />
                                        }

                                        <!-- DOCUMENTS -->
                                        @if (operation.type === OPERATION_TYPE.DOCUMENTS && form.get(`operations.${OPERATION_TYPE.DOCUMENTS}.available`).value && operation.selected) {
                                        	<app-workflow-form-documents-panel [host]="asOperationPanelHost" [operation]="operation" />
                                        }

                                        <!-- CONNECTIONS -->
                                        @if (operation.type === OPERATION_TYPE.CONNECTIONS && form.get(`operations.${OPERATION_TYPE.CONNECTIONS}.available`).value && operation.selected) {
                                        	<app-workflow-form-connections-panel [host]="asOperationPanelHost" [operation]="operation" />
                                        }

                                        <!-- FINISH -->
                                        @if (operation.type === OPERATION_TYPE.FINISH && form.get(`operations.${OPERATION_TYPE.FINISH}.available`).value && operation.selected) {
                                        	<app-workflow-form-finish-panel [host]="asOperationPanelHost" [operation]="operation" />
                                        }
                                    }
                                </div>
                            </div>
                        }
                    </ng-container>
                }

                <!-- Confirmation -->
                @if (steps[2].selected) {
                    <div class="layout--50-50">
                        <div class="layout__column">
                            <tec-tile type="banner-horizontal"
                                [title]="'WORKFLOWS.FORM.CONFIRMATION.READY' | translate"
                                [subtitle]="'WORKFLOWS.FORM.CONFIRMATION.READY_DESCRIPTION' | translate"
                            />
                            <tec-tile [title]="'WORKFLOWS.FORM.CONFIRMATION.CONFIGURATION' | translate" icon="icon-capture-popup">
                                <div class="grid grid-i2">
                                    <tec-info-group [label]="'WORKFLOWS.FORM.GENERAL.NAME' | translate">
                                        <span>{{ form.get('general.alias').value || ('GENERAL.NOT_AVAILABLE' | translate) }}</span>
                                    </tec-info-group>
                                    <tec-info-group [label]="'WORKFLOWS.FORM.GENERAL.VALIDATION_TYPE' | translate">
                                        @if ((form.get('general.validation').value?.id || form.get('general.validation').value) === 'auto') {
                                            <tec-tag [label]="'WORKFLOWS.FORM.GENERAL.VALIDATION_TYPE_OPT.AUTO' | translate"></tec-tag>
                                        }
                                        @if ((form.get('general.validation').value?.id || form.get('general.validation').value) === 'manual') {
                                            <tec-tag [label]="'WORKFLOWS.FORM.GENERAL.VALIDATION_TYPE_OPT.MANUAL' | translate"></tec-tag>
                                        }
                                    </tec-info-group>
                                    <tec-info-group [label]="'WORKFLOWS.FORM.GENERAL.THEME_DESIGN' | translate">
                                        {{ form.get('general.theme').value?.label || ('GENERAL.NOT_AVAILABLE' | translate) }}
                                    </tec-info-group>
                                </div>
                            </tec-tile>
                            <div class="grid grid-i2 item-group">
                                <tec-item [title]="'WORKFLOWS.FORM.GENERAL.LOCATION' | translate"
                                    [tagImage]="{icon: 'icon-map-pin', status: 'default'}">
                                    <tec-list-detail>
                                        <app-workflow-form-active-status-tag
                                            [active]="!!form.get('general.location').value"
                                        />
                                    </tec-list-detail>
                                </tec-item>
                                <tec-item [title]="'WORKFLOWS.FORM.GENERAL.REQUIRED_RECORDING' | translate"
                                    [tagImage]="{icon: 'icon-video-camera', status: 'default'}">
                                    <app-workflow-form-active-status-tag
                                        [active]="!!form.get('general.required_recording').value"
                                    />
                                </tec-item>
                                <tec-item [title]="'WORKFLOWS.FORM.GENERAL.ALLOWED_DEVICE' | translate"
                                    [tagImage]="{icon: 'icon-smartphone', status: 'default'}">
                                    @for (device of form.get('general.allowed_device').value; track $index) {
                                        <tec-tag [label]="device.label || masterService.getNameAllowedDevice(device)" status="default"></tec-tag>
                                    }
                                </tec-item>
                                <tec-item [title]="'WORKFLOWS.FORM.GENERAL.HAS_SAVED_STATE' | translate"
                                    [tagImage]="{icon: 'icon-refresh', status: 'default'}">
                                    @if ((form.get('general.has_saved_state').value?.id || form.get('general.has_saved_state').value) === 'true') {
                                        <tec-tag [label]="'BUTTON.CONTINUE' | translate" status="default"></tec-tag>
                                    } @else {
                                        <tec-tag [label]="'BUTTON.RESET' | translate" status="default"></tec-tag>
                                    }
                                </tec-item>
                            </div>
                        </div>
                        <tec-tile [title]="'WORKFLOWS.FORM.OPERATIONS.TITLE' | translate" icon="icon-list">
                            <div class="item-group">
                                @for (operation of operationsFiltered; track $index) {
                                    <tec-item [title]="operation.title"
                                        [tagImage]="{img: operation.image}">
                                        @if (operation.type === OPERATION_TYPE.FINISH) {
                                            <tec-button-icon icon="icon-edit"
                                                (clickEvent)="moveToOperation(operation)"
                                            ></tec-button-icon>
                                        } @else {
                                            <tec-menu
                                                [options]="workflowsHelper.operationMenuOpt"
                                                (valueChange)="operationMenuChange($event, operation)">
                                                <tec-button-icon
                                                    [icon]="'icon-more'"
                                                    [type]="'default'"
                                                ></tec-button-icon>
                                            </tec-menu>
                                        }
                                    </tec-item>
                                }
                            </div>
                        </tec-tile>
                    </div>
                }
            }
        }

        @if (!workflowReady) {
            <tec-button
                [label]="'BUTTON.EXIT' | translate"
                [type]="'secondary'"
                (clickEvent)="cancel()"
            ></tec-button>
        }

        @if (!workflowReady) {
            <tec-button
                [label]="steps[steps.length-1].selected ? (id ? ('BUTTON.UPDATE' | translate) : ('BUTTON.SAVE' | translate)) : ('BUTTON.CONTINUE' | translate)"
                [type]="'default'"
                (clickEvent)="globalContinue()"
            ></tec-button>
        }

        @if (!workflowReady && steps.length && !steps.at(0)?.selected && !id) {
            <tec-link [label]="'BUTTON.SAVE_DRAFT' | translate"></tec-link>
        }

    </tec-create-layout>
} @else {
    <tec-empty-state
        [title]="'WORKFLOWS.FORM.DETAIL_ERROR' | translate"
        [description]="errorDetail"
        [size]="'default'"
        [type]="'error'"
    ></tec-empty-state>
}

@if (showModalTermsConditions) {
    <app-legal-terms-form [company]="form.get('general.company').value" (closeEvent)="createPolicyCheck($event)" />
}

@if (modalDocForm) {
    <app-modal-doc-form [info]="modalDocForm" [operationSelected]="operationsFiltered" (closeEvent)="formDoc($event)"></app-modal-doc-form>
}

@if (modalFormStep) {
    <app-modal-workflow-form-step [info]="modalFormStep" (closeEvent)="formStep($event)"></app-modal-workflow-form-step>
}

@if (showModalOcrFraudScoring?.show) {
    <app-modal-ocr-fraud-scoring [form]="showModalOcrFraudScoring.form" (closeEvent)="saveOcrFraud($event)"></app-modal-ocr-fraud-scoring>
}

@if (showModalFormOcrOrder?.show) {
	<app-modal-workflow-form-ocr-order
		[mode]="showModalFormOcrOrder.mode"
		[autofillFromOcr]="form.get('operations.' + OPERATION_TYPE.FORM + '.autofill_from_ocr')?.value"
		(closeEvent)="onFormOcrOrderModalClose($event)"
	></app-modal-workflow-form-ocr-order>
}

@if (showModalFinishResultMessages?.show) {
    <app-modal-finish-result-messages
        [form]="showModalFinishResultMessages.form"
        [localeTabs]="workflowLocaleTabs"
        (closeEvent)="saveFinishResultMessages($event)"
    ></app-modal-finish-result-messages>
}

@if (showCreateApikeyForm) {
    <app-apikey-form [company]="form.get('general.company').value" (closeEvent)="closeApikeyForm($event)"></app-apikey-form>
}
